module.exports = __webpack_public_path__ + "img/appid1.1840050d.png";